import React from 'react';
import styles from '../RateView.module.css';
import { getCurrentResource } from '../../../util/tools';
import FilterLabel from './FilterLabel';

class FilterOwnEntities extends React.Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.rateview.filter.FilterOwnEntities;		

		let initialValue = props.filter.initialValue;
		if( initialValue == null )
			initialValue = '';
		let checked = (initialValue == 'true'); 

		let q = props.rateView.query;
		let indexFilter = -1;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter < 0 ) {
			let predicate = {
				predicateId: props.filter.predicateId,
				value: checked ? '1' : '0'
			};
			q.listPredicate.push( predicate );
		}
		
		this.state = {
			checked: checked
		}
	}
	componentDidMount() {
		let rateView = this.props.rateView;
		rateView.registerFilter( this );
	}
	componentWillUnmount() {
		let rateView = this.props.rateView;
		rateView.unregisterFilter( this );
	}

	clearFilter() {
		console.log('Clear own filter')
		const checked = false;
		this.setFilterValue(checked);
		this.setState({checked: checked});
		console.log('clear filter. state', this.state)
	}	
	handleCheckBoxChange = e => {
		console.log('handleCheckBoxChange')
		this.props.rateView.clearData();
		const checked = e.target.checked;
		this.setFilterValue(checked);
		this.setState({checked: checked});
	}
	setFilterValue = (checked) => {
		let q = this.props.rateView.query;
		let indexFilter = -1;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		q.listPredicate[indexFilter].value = checked ? '1' : '0';
	}	

	fetchProfile = () => {
		if( this.state.checked )
			return {filterId: this.props.filter.predicateId, value: true};
		else
			return null;
	}
	applyProfile = (profile) => {
		this.setFilterValue(profile.value);
		this.setState({checked: profile.value});
	}
	
	render() {
		let filter = this.props.filter;
		return (
			<div className={styles.divFilter}>
				<div className={styles.divFilterInput}>
					<input type="checkbox" onChange={this.handleCheckBoxChange} checked={this.state.checked}/>
					<FilterLabel title={filter.title} tooltip={filter.tooltip} />
				</div>
			</div>
		);
	}	
}

export default FilterOwnEntities;
